<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox mt20">
                <h5>{{mainmenuitem.title}}</h5>
                <p>{{mainmenuitem.description}}</p>
            </div>
            <ul class="titlemenu mt50">
                <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                    <a href="javascript:void(0)" @click="gotolist(menu)">{{menu.title}}</a>
                </li>
            </ul>
        </div>
        <div class="p_body container mt50">
            <div class="p_body_content">
                <div class="p_body_content_title fontbold">
                    <h5 class="body_info_title">{{itemData.title}}</h5>
                </div>
                <div class="p_body_content_stuff mt20" v-html="itemData.content"></div>
            </div>
        </div>
    </div>
</template>


<script>

import configration from '../tools/js/enumconfig'

export default {
    data(){
        return {
            totleCount:0,
            itemData:{},
 
            id:'',
            mainmenuitem:{},            //主显示分类
            childmenutree:[],   //  treemenu
            childmenus:[],
            fid:'',
            pid:'',

            showtitle:'主营业务',
            imgbaseurl : this.$baseURL.fileurl,

        }
    },
     methods:{
        getData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                }
            });
        },

        initmenu(){
            let vm = this;
            if(vm.childmenutree == undefined || vm.childmenutree.length == 0) 
            { 
                vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
            }

            vm.childmenus = [];
            if(vm.fid.length>0){
                //获取子菜单
                for(let i=0;i< vm.childmenutree.length;i++ ){
                    if(vm.childmenutree[i].id == vm.fid)
                    {
                        vm.mainmenuitem = vm.childmenutree[i];
                        vm.childmenus = vm.childmenutree[i].childs;
                        break;
                    }
                }
            }

        },

        gotolist(item){
            const vm = this;
            vm.$router.push({path:'/business/list',query:{pid:item.id,fid:item.parentId}});
        },
        initpage(){
            let vm = this;
            //绑定
            if(vm.$route.query.id!=undefined && vm.$route.query.id.length>0)
            {
                vm.id = vm.$route.query.id;
                vm.getData(vm.$route.query.id);
            }
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.pid = vm.$route.query.pid;
            }
            if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0)
            {
                vm.fid = vm.$route.query.fid;
            }
            vm.initmenu();
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();
    }
}
</script>

